module.exports = __webpack_public_path__ + "static/img/energy-h5-5.6d43bcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/energy-h5-5.png
// module id = LBrr
// module chunks = 34